module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-25.6479a6fa.png";